import React from 'react';
import CustomSelect from '../components/CustomSelect';

const LearningPageHeader = ({ 
  currentLanguage, 
  switchLanguage, 
  currentMicroIndex, 
  totalMicroChunks, 
  backToChunks 
}) => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white'
    }}>
      {/* Row 1: Language + Back to Chunks */}
      <div style={{
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
      }}>
      <button 
          onClick={backToChunks}
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Chunks
        </button>

      {/* Language Selector */}
      <div style={{ width: '150px' }}>
        <CustomSelect
          value={currentLanguage}
          onChange={(e) => switchLanguage(e.target.value)}
          options={[
            { value: 'en', label: '🇺🇸 English' },
            { value: 'hi', label: '🇮🇳 Hindi' }
          ]}
          placeholder="Select Language"
        />
      </div>
      </div>

      {/* Row 2: Point Progress */}
      <div style={{
        padding: '10px 20px',
        textAlign: 'center',
        borderTop: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <p style={{margin: 0, fontSize: '1rem', fontWeight: '600'}}>
          Point {currentMicroIndex + 1} of {totalMicroChunks}
        </p>
      </div>
    </div>
  );
};

export default LearningPageHeader;